define([
  "backbone",
  "jquery",
  "marionette",
  "underscore",
  "messaging/messenger",
  "./taskStepsView",
  "modules/tasks/tasksModel",
], function (Backbone, $, Marionnete, _, Messenger, TaskStepsView, TaskModel) {
  "use strict";

  return Marionnete.Controller.extend({
    initialize: function (options) {
      this.languageId = options.languageId;
      this.region = options.region;
      this.name = "taskSteps";
      if (options.stepsRequired !== undefined && options.stepsRequired !== null) {
        this.stepsRequired = options.stepsRequired;
      } else {
        this.stepsRequired = true;
      }
    },
    show: function (task) {
      this.task = task;
      this.taskSteps = task.steps();
      this.collection = new Backbone.Collection();
      const kbId = Messenger.reqres.request("active:kb");
      this.collection.departments = Messenger.reqres.request("kb:departments", {
        kbId: kbId,
        includeUsers: true,
      });
      this.view = new TaskStepsView.stepsView({ collection: this.collection });
      this.view.on("add:step", this._onAddStep, this);
      this.view.on("itemview:add:assignee", this._onAddAssignee, this);
      this.view.on("itemview:change:assignee:canEdit", this._onChangeAssigneeCanEdit, this);
      this.view.on("itemview:change:assignee:department", this._onChangeAssigneeDepartment, this);
      this.view.on("itemview:change:assignee:user", this._onChangeAssigneeUser, this);
      this.view.on("itemview:remove:assignee", this._onRemoveAssignee, this);
      this.view.on("itemview:change:step:instructions", this._onChangeStepInstructions, this);
      this.collection.departments.onSynced(function () {
        this._processTaskSteps();
      }, this);
      this.showRegion(this.view, { loading: true, entity: this.collection.departments });
    },
    changeLanguage: function (newLanguageId) {
      const oldLanguageId = this.languageId;
      this.languageId = newLanguageId;
      this.taskSteps.each(function (step) {
        if (step.get("languageId") == oldLanguageId) {
          step.set("languageId", newLanguageId);
        }
      }, this);
      this._processTaskSteps();
    },
    commitData: function () {
      this.view.clearErrors();
      let valid = true;
      if (this.collection.length === 0) {
        if (this.stepsRequired) {
          this.view.stepsError($.t("task.wizard.emptySteps"));
          valid = false;
        }
      } else {
        this.collection.each(function (stepAndAssignee) {
          if (!stepAndAssignee.isValid()) {
            valid = false;
          }
        });
      }
      return valid;
    },
    isEmpty: function () {
      return this.collection.length === 0;
    },
    _onAddAssignee: function (itemView) {
      const step = itemView.model.taskStep;
      itemView.model.set("lastAssignee", false);
      const assignee = step.assignees().addAssignee();
      const newModel = TaskModel.taskStepAndAssignee.createFromStepAndAssignee(
        step,
        assignee,
        step.assignees(),
        step.assignees().length - 1,
        this.languageId,
        this.collection.departments,
      );
      const index = this.collection.indexOf(itemView.model);
      this.collection.add(newModel, { at: index + 1 });
    },
    _onAddStep: function () {
      const step = this.taskSteps.addStep(this.languageId);
      const assignee = step.assignees().addAssignee();
      const model = TaskModel.taskStepAndAssignee.createFromStepAndAssignee(
        step,
        assignee,
        step.assignees(),
        0,
        this.languageId,
        this.collection.departments,
      );
      this.collection.add(model);
    },
    _onChangeAssigneeCanEdit: function (itemView, options) {
      const value = options.value;
      const model = options.model;
      model.set("canEdit", value);
      model.taskStepAssignee.set("canEdit", value);
    },
    _onChangeAssigneeDepartment: function (itemView, options) {
      const departmentId = options.value;
      const department = this.collection.departments.get(departmentId);
      const users = this._filterUsers(department.users());
      const model = options.model;
      const assigneeData = {
        departmentId: departmentId,
        departmentUsers: users,
        userId: 0,
        allUsers: users.length > 0,
        // DO NOT set instructions here, otherwise the taskStepAssignee will have instructions, which is wrong
      };
      const modelData = _.extend(
        {
          instructions: department.get("taskDescription"),
        },
        assigneeData,
      );
      model.set(modelData);
      model.taskStepAssignee.set(assigneeData);
      model.taskStep.set("instructions", department.get("taskDescription"));
    },
    _onChangeAssigneeUser: function (itemView, options) {
      const userId = options.value;
      const model = options.model;
      let updateData;
      if (userId == "all") {
        updateData = {
          userId: 0,
          allUsers: true,
        };
      } else if (userId == "none") {
        updateData = {
          userId: 0,
          allUsers: false,
        };
      } else {
        updateData = {
          userId: userId,
          allUsers: false,
        };
      }
      model.set(updateData);
      model.taskStepAssignee.set(updateData);
    },
    _onChangeStepInstructions: function (itemView, options) {
      const model = options.model;
      model.set("instructions", options.value);
      model.taskStep.set("instructions", options.value);
    },
    _onRemoveAssignee: function (itemView) {
      const model = itemView.model;
      const step = model.taskStep;
      const assignee = model.taskStepAssignee;
      const assignees = step.assignees();
      assignees.remove(assignee);
      const assigneesLength = assignees.length;
      if (assigneesLength === 0) {
        this.taskSteps.remove(step);
      } else {
        const lastAssignee = assignees.at(assigneesLength - 1);
        this.collection.each(function (m) {
          if (m.taskStep === step) {
            if (m.taskStepAssignee === lastAssignee) {
              m.set("lastAssignee", true);
            } else {
              m.set("lastAssignee", false);
            }
          }
        });
      }
      this.collection.remove(model);
    },
    _filterUsers: function (allUsers) {
      return TaskModel.taskStepAndAssignee.filterUsers(allUsers, this.languageId);
    },
    _findAssignee: function (userId, assignees) {
      let assignee = null;
      let departmentAssignee = null;
      assignees.each(function (a) {
        if (a.get("userId") == userId) {
          assignee = a;
          return false;
        }
        if (!departmentAssignee) {
          const departmentId = a.get("departmentId");
          if (departmentId) {
            const departments = this.collection.departments;
            const department = departments.get(departmentId);
            const departmentUsers = this._filterUsers(department.users());
            const departmentUser = _.find(departmentUsers, function (u) {
              return u.id == userId;
            });
            if (departmentUser) {
              departmentAssignee = a;
            }
          }
        }
      }, this);
      if (assignee) {
        return assignee;
      }
      return assignee || departmentAssignee;
    },
    _processTaskSteps: function () {
      const models = [];
      const taskSteps = this.taskSteps;
      taskSteps.each(function (taskStep) {
        const taskStepLanguageId = taskStep.get("languageId");
        if (
          (taskStepLanguageId <= 0 && this.languageId <= 0) ||
          taskStepLanguageId == this.languageId
        ) {
          const userId = taskStep.get("userId");
          let assignees = taskStep.assignees();
          if (userId > 0) {
            const assignee = this._findAssignee(userId, assignees);
            if (assignee) {
              assignee.set({
                allUsers: false,
                userId: userId,
                userName: taskStep.get("userName"),
              });
              assignees = new Backbone.Collection([assignee]);
              var model = TaskModel.taskStepAndAssignee.createFromStepAndAssignee(
                taskStep,
                assignee,
                assignees,
                0,
                this.languageId,
                this.collection.departments,
              );
              models.push(model);
              return;
            }
          }
          assignees.each(function (taskStepAssignee, assigneeIndex) {
            const model = TaskModel.taskStepAndAssignee.createFromStepAndAssignee(
              taskStep,
              taskStepAssignee,
              assignees,
              assigneeIndex,
              this.languageId,
              this.collection.departments,
            );
            models.push(model);
          }, this);
        }
      }, this);
      this.collection.reset(models);
    },
    _validateAssignee: function (assignee) {
      return (
        assignee.get("departmentId") > 0 && (assignee.get("userId") > 0 || assignee.get("allUsers"))
      );
    },
  });
});
